<template>
  <div class="content-footer">
    <div class="px-16">
      <Separator class="mt-30 mb-30" />
      <span class="title-typo-1"> 유심사와 함께하는 간편한 여행 ✈️ </span>
      <p class="typo-1 mt-default mb-30">
        여행은 준비 과정부터 즐거워야 해요!<br />
        여행자님의 완벽한 여정을 위한 끊김 없는 데이터는 유심사가 책임질게요.
      </p>

      <p class="typo-1">
        여행자님, 궁금한 점이 있으신가요?<br />
        24시간 연중무휴 운영 중인 유심사 고객센터로 언제든 편하게 문의해주세요.
      </p>

      <div
        class="title-typo-1 link mt-12 mb-30"
        @click="handleMoveToserviceCenter"
      >
        유심사 24시간 고객센터 연결 💬
      </div>

      <Separator class="mt-30 mb-30" />
      <div class="mb-40">
        <p class="title-typo-1 mb-default">900만의 여행 필수품, 유심사</p>
        <nuxt-img
          width="94"
          src="img/main/usimsa-logo-v2.svg"
        />
      </div>
    </div>

    <ADivider class="mt-30 mb-30" />
    <div class="px-16">
      <CtaButton
        id="gtm_contents_share_btn"
        w-full
        size="lg"
        type="tertiary"
        @click-button="emits('click-share')"
      >
        <div class="flex flex-align-center flex-justify-center gap-4">
          <Icons
            path="outline/share"
            size="18"
          />
          <span>공유하기</span>
        </div>
      </CtaButton>
    </div>
  </div>
</template>

<script setup lang="ts">
const emits = defineEmits(['click-share'])
const handleMoveToserviceCenter = () => {
  window.location.href = '/board/contact-channel'
}
</script>
